<template>
    <ts-loading-banner :loading="waiting">
        <div class="tw-space-y-2">
            <div class="card border-0 shadow-none">
                <div>
                    <div class="row">
                        <div class="col-lg-3 mb-3 mb-lg-0">
                            <div class="tw-rounded-lg tw-p-3 tw-bg-white">
                                <div class="tw-w-40 tw-max-w-full">
                                    <div class="tw-w-full tw-h-32 tw-bg-gray-100 tw-rounded tw-overflow-hidden">
                                        <img
                                            :src="logo_file_src"
                                            alt=""
                                            class="tw-object-contain tw-w-full tw-h-full"
                                        />
                                    </div>
                                    <input
                                        type="file"
                                        id="logo-image"
                                        ref="logoimage"
                                        style="display:none"
                                        @change="onFileChange"
                                    />
                                    <button
                                        type="button"
                                        class="btn btn-primary mt-3 tw-w-full"
                                        @click.prevent="triggerLogoBrowse"
                                    >
                                        {{ $t("browseFile") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-9">
                            <div class="row">
                                <div class="col-md-6 mb-2">
                                    <label>{{ $t("companyProfile.nameKH") }}</label>
                                    <input
                                        v-model="model.company_name_kh"
                                        type="text"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has('company_name_kh')
                                        }"
                                        :placeholder="$t('companyProfile.nameKH')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_name_kh')"
                                    >
                                        {{ errors.first("company_name_kh") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="required">{{
                                        $t("companyProfile.nameEN")
                                    }}</label>
                                    <input
                                        v-model="model.company_name_en"
                                        type="text"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has('company_name_en')
                                        }"
                                        :placeholder="$t('companyProfile.nameEN')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_name_en')"
                                    >
                                        {{ errors.first("company_name_en") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="required">{{
                                        $t("companyProfile.prefixCode")
                                    }}</label>
                                    <input
                                        v-model="model.prefix_code"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('prefix_code') }"
                                        :placeholder="$t('companyProfile.prefixCode')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('prefix_code')"
                                    >
                                        {{ errors.first("prefix_code") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label class="required">{{
                                        $t("companyProfile.phone")
                                    }}</label>
                                    <input
                                        v-model="model.company_phone"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('company_phone') }"
                                        :placeholder="$t('companyProfile.phone')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_phone')"
                                    >
                                        {{ errors.first("company_phone") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label>{{ $t("companyProfile.email") }}</label>
                                    <input
                                        v-model="model.company_email"
                                        type="email"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('company_email') }"
                                        :placeholder="$t('companyProfile.email')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_email')"
                                    >
                                        {{ errors.first("company_email") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label>{{ $t("companyProfile.website") }}</label>
                                    <input
                                        v-model="model.company_website"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('company_website') }"
                                        :placeholder="$t('companyProfile.website')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_website')"
                                    >
                                        {{ errors.first("company_website") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <label>{{ $t("companyProfile.city") }}</label>
                                    <input
                                        v-model="model.company_city"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('company_city') }"
                                        :placeholder="$t('companyProfile.city')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_city')"
                                    >
                                        {{ errors.first("company_city") }}
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <label>{{ $t("companyProfile.zipCode") }}</label>
                                    <input
                                        v-model="model.zip_code"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('zip_code') }"
                                        :placeholder="$t('companyProfile.zipCode')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('zip_code')"
                                    >
                                        {{ errors.first("zip_code") }}
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <label>{{ $t("companyProfile.faxNumber") }}</label>
                                    <input
                                        v-model="model.company_fax"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors.has('company_fax') }"
                                        :placeholder="$t('companyProfile.faxNumber')"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('company_fax')"
                                    >
                                        {{ errors.first("company_fax") }}
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <input
                                        type="file"
                                        ref="shopKmlFile"
                                        accept=".kml"
                                        style="display:none"
                                        @change="onKmlFileChange('shop')"
                                    />
                                    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-h-11 tw-px-3 tw-rounded-md tw-border tw-border-gray-200 tw-bg-white hover:tw-border-blue-300 tw-transition-colors">
                                        <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                                            <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-bg-blue-50 tw-text-blue-600">
                                                <i class="fa fa-file-code"></i>
                                            </span>
                                            <div class="tw-min-w-0">
                                                <div class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-leading-tight">
                                                    {{ $t("companyProfile.shopKmlFile") }}
                                                </div>
                                                <div class="tw-text-xs tw-text-gray-500 tw-truncate">
                                                    {{ shopKmlFileName }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                                            <a
                                                v-if="model.shop_kml_file"
                                                :href="model.shop_kml_file"
                                                target="_blank"
                                                class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-border tw-border-gray-200 tw-bg-gray-50 tw-text-gray-600 hover:tw-bg-gray-100"
                                                :title="$t('view')"
                                            >
                                                <i class="fa fa-eye"></i>
                                            </a>
                                            <button
                                                type="button"
                                                class="tw-inline-flex tw-items-center tw-gap-1 tw-h-8 tw-px-3 tw-rounded-md tw-border-0 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-text-xs tw-font-semibold"
                                                @click.prevent="triggerKmlBrowse('shop')"
                                            >
                                                <i class="fa fa-upload"></i>
                                                <span>{{ $t("browseFile") }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <input
                                        type="file"
                                        ref="driverKmlFile"
                                        accept=".kml"
                                        style="display:none"
                                        @change="onKmlFileChange('driver')"
                                    />
                                    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-h-11 tw-px-3 tw-rounded-md tw-border tw-border-gray-200 tw-bg-white hover:tw-border-blue-300 tw-transition-colors">
                                        <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                                            <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-bg-green-50 tw-text-green-600">
                                                <i class="fa fa-file-code"></i>
                                            </span>
                                            <div class="tw-min-w-0">
                                                <div class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-leading-tight">
                                                    {{ $t("companyProfile.driverKmlFile") }}
                                                </div>
                                                <div class="tw-text-xs tw-text-gray-500 tw-truncate">
                                                    {{ driverKmlFileName }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                                            <a
                                                v-if="model.driver_kml_file"
                                                :href="model.driver_kml_file"
                                                target="_blank"
                                                class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-border tw-border-gray-200 tw-bg-gray-50 tw-text-gray-600 hover:tw-bg-gray-100"
                                                :title="$t('view')"
                                            >
                                                <i class="fa fa-eye"></i>
                                            </a>
                                            <button
                                                type="button"
                                                class="tw-inline-flex tw-items-center tw-gap-1 tw-h-8 tw-px-3 tw-rounded-md tw-border-0 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-text-xs tw-font-semibold"
                                                @click.prevent="triggerKmlBrowse('driver')"
                                            >
                                                <i class="fa fa-upload"></i>
                                                <span>{{ $t("browseFile") }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-border-t tw-border-gray-300 tw-my-2"></div>
            <div class="border-0 shadow-none">
                <div>
                    <div class="tw-flex tw-items-center tw-justify-between tw-h-10 tw-bg-gray-100 tw-rounded-md tw-px-3">
                        <label class="tw-mb-0 tw-text-gray-700 tw-font-semibold">
                            {{ $t("companyProfile.bankAccount") }}
                        </label>
                        <button
                            type="button"
                            class="tw-inline-flex tw-items-center tw-gap-1 tw-h-7 tw-px-2 tw-rounded-md tw-border-0 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-text-xs tw-font-semibold tw-leading-none tw-transition-colors"
                            @click.prevent="addBank"
                        >
                            <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-3 tw-h-3 tw-rounded-full tw-bg-white tw-text-blue-600">
                                <i class="fa fa-plus tw-text-[10px]"></i>
                            </span>
                            <span>{{ $t("addNew") }}</span>
                        </button>
                    </div>
                    <div
                        v-if="model.payment_info.length"
                        class="tw-mt-2 tw-flex tw-flex-col tw-rounded-md tw-border tw-border-gray-200 tw-bg-gray-50 tw-overflow-hidden"
                        style="max-height: 320px; min-height: 100px;"
                    >
                        <div
                            class="tw-grid tw-gap-2 tw-px-3 tw-py-2 tw-border-b tw-border-gray-200 tw-bg-gray-100 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-500"
                            style="grid-template-columns: 40px 1.25fr .8fr .8fr 1.2fr 1.2fr 52px;"
                        >
                            <div class="tw-whitespace-nowrap tw-text-center">#</div>
                            <div class="tw-whitespace-nowrap">
                                {{ $t("companyProfile.bankName") }}
                                <span class="tw-text-red-500">*</span>
                            </div>
                            <div class="tw-whitespace-nowrap">
                                {{ $t("companyProfile.currencyCode") }}
                                <span class="tw-text-red-500">*</span>
                            </div>
                            <div class="tw-whitespace-nowrap">
                                {{ $t("companyProfile.currencySign") }}
                                <span class="tw-text-red-500">*</span>
                            </div>
                            <div class="tw-whitespace-nowrap">
                                {{ $t("companyProfile.accountNumber") }}
                                <span class="tw-text-red-500">*</span>
                            </div>
                            <div class="tw-whitespace-nowrap">
                                {{ $t("companyProfile.accountName") }}
                                <span class="tw-text-red-500">*</span>
                            </div>
                            <div class="tw-text-center tw-whitespace-nowrap">{{ $t("actions") }}</div>
                        </div>
                        <div
                            class="tw-flex-1 tw-overflow-y-auto tw-p-3 tw-space-y-2"
                            style="min-height: 0;"
                        >
                            <div
                                v-for="(payment, index) in model.payment_info"
                                :key="index"
                                class="tw-grid tw-gap-2 tw-items-center tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-p-2 hover:tw-border-blue-200 hover:tw-shadow-sm"
                                style="grid-template-columns: 40px 1.25fr .8fr .8fr 1.2fr 1.2fr 52px;"
                            >
                                <div class="tw-flex tw-justify-center">
                                    <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-100 tw-text-xs tw-font-semibold tw-text-gray-600">
                                        {{ index + 1 }}
                                    </span>
                                </div>
                                <div>
                                    <a-select
                                        v-model="payment.bank_name"
                                        :options="bankNameOptions"
                                        class="tw-w-full"
                                        :placeholder="
                                            errors.first(
                                                'payment_info.' +
                                                    index +
                                                    '.bank_name'
                                            )
                                        "
                                    />
                                </div>
                                <div>
                                    <a-select
                                        v-model="payment.currency_code"
                                        :options="currencyCodeOptions"
                                        class="tw-w-full"
                                        :placeholder="
                                            errors.first(
                                                'payment_info.' +
                                                    index +
                                                    '.currency_code'
                                            )
                                        "
                                        @change="onCurrencyCodeChange(payment, $event)"
                                    />
                                </div>
                                <div>
                                    <a-select
                                        v-model="payment.currency_sign"
                                        :options="currencySignOptions"
                                        class="tw-w-full"
                                        :placeholder="
                                            errors.first(
                                                'payment_info.' +
                                                    index +
                                                    '.currency_sign'
                                            )
                                        "
                                        @change="onCurrencySignChange(payment, $event)"
                                    />
                                </div>
                                <div>
                                    <input
                                        v-model.trim="payment.account_number"
                                        type="text"
                                        class="form-control form-control-sm tw-rounded-md"
                                        :placeholder="
                                            errors.first(
                                                'payment_info.' +
                                                    index +
                                                    '.account_number'
                                            )
                                        "
                                    />
                                </div>
                                <div>
                                    <input
                                        v-model.trim="payment.account_name"
                                        type="text"
                                        class="form-control form-control-sm tw-rounded-md"
                                        :placeholder="
                                            errors.first(
                                                'payment_info.' +
                                                    index +
                                                    '.account_name'
                                            )
                                        "
                                    />
                                </div>
                                <div class="tw-flex tw-justify-center">
                                    <button
                                        type="button"
                                        class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-border tw-border-red-200 tw-bg-white tw-text-red-500 hover:tw-bg-red-50 hover:tw-border-red-300"
                                        @click.prevent="removeBank(index)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="tw-flex tw-items-center tw-justify-center tw-border tw-rounded tw-py-3 tw-mt-2"
                        style="height: 100px;"
                    >
                        <div class="tw-w-full tw-text-center">
                            <a-empty
                                :description="$t('noData')"
                                :image-style="{ height: '42px' }"
                                style="margin: 0;"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card border-0 shadow-none">
                <div>
                    <div class="tw-flex tw-items-center tw-justify-between tw-h-10 tw-bg-gray-100 tw-rounded-md tw-px-3 tw-mb-2">
                        <label class="tw-mb-0 tw-text-gray-700 tw-font-semibold">
                            {{ $t("companyProfile.address") }}
                        </label>
                        <span class="tw-w-5"></span>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 tw-mb-3 tw-mb-lg-0">
                            <textarea
                                v-model="model.company_address"
                                rows="13"
                                class="form-control"
                                :placeholder="$t('companyProfile.address')"
                                :class="{ 'is-invalid': errors.has('company_address') }"
                            ></textarea>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('company_address')"
                            >
                                {{ errors.first("company_address") }}
                            </div>
                        </div>
                        <div class="col-lg-8">
                            <GmapMap
                                :center="center"
                                :zoom="zoom"
                                :options="{
                                    streetViewControl: true
                                }"
                                map-type-id="roadmap"
                                class="tw-w-full"
                                style="height: 250px;"
                                @click="mapClick"
                            >
                                <GmapMarker
                                    :clickable="true"
                                    :draggable="true"
                                    :position="marker"
                                />
                            </GmapMap>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
                    <ts-button
                        class="mr-2"
                        @click.prevent="() => $emit('cancel')"
                    >
                        {{ $t("cancel") }}
                    </ts-button>
                    <ts-button
                        v-if="!isUpdate"
                        color="primary"
                        @click.prevent="onSave"
                        >{{ $t("save") }}</ts-button
                    >
                    <ts-button
                        v-if="isUpdate"
                        color="primary"
                        @click.prevent="onUpdate"
                        >{{ $t("update") }}</ts-button
                    >
                </div>
            </div>
        </div>
    </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
    name: "companyForm",
    data() {
        return {
            waiting: false,
            errors: new Errors(),
            logo_file: "",
            shop_kml_file: null,
            driver_kml_file: null,
            logo_file_src: require("../../../assets/default-image.jpg"),
            zoom: 7,
            center: { lat: 12.565679, lng: 104.990967 },
            marker: { lat: undefined, lng: undefined },
            bankNameOptions: [
                { value: "ABA", label: "ABA" },
                { value: "ACLEDA", label: "ACLEDA" },
                { value: "Canadia", label: "Canadia" },
                { value: "Wing", label: "Wing" },
                { value: "Sathapana", label: "Sathapana" },
                { value: "Prince", label: "Prince" },
                { value: "J Trust Royal", label: "J Trust Royal" },
                { value: "Vattanac", label: "Vattanac" },
                { value: "PPCBank", label: "PPCBank" },
                { value: "Chip Mong", label: "Chip Mong" },
                { value: "Maybank", label: "Maybank" }
            ],
            currencyOptions: [
                { code: "KHR", sign: "៛", label: "Khmer Riel" },
                { code: "USD", sign: "$", label: "US Dollar" }
            ],
            model: {
                company_id: null,
                prefix_code: null,
                company_name_kh: null,
                company_name_en: null,
                company_address: null,
                company_phone: null,
                company_email: null,
                company_website: null,
                company_logo: null,
                shop_kml_file: null,
                driver_kml_file: null,
                payment_info: [],
                geo_location: {
                    lat: "",
                    lng: ""
                }
            }
        };
    },
    computed: {
        ...mapState("corporate/companyProfile", ["edit_data"]),
        currencyCodeOptions() {
            return this.currencyOptions.map(item => ({
                value: item.code,
                label: item.code
            }));
        },
        currencySignOptions() {
            return this.currencyOptions.map(item => ({
                value: item.sign,
                label: item.sign
            }));
        },
        isUpdate() {
            return !isEmpty(this.edit_data);
        },
        shopKmlFileName() {
            if (this.shop_kml_file instanceof File) {
                return this.shop_kml_file.name;
            }

            return this.model.shop_kml_file ? "KML file uploaded" : "No file selected";
        },
        driverKmlFileName() {
            if (this.driver_kml_file instanceof File) {
                return this.driver_kml_file.name;
            }

            return this.model.driver_kml_file ? "KML file uploaded" : "No file selected";
        }
    },
    created() {
        this.setEditData();
    },
    methods: {
        triggerLogoBrowse() {
            this.$refs.logoimage.click();
        },
        triggerKmlBrowse(type) {
            this.$refs[`${type}KmlFile`].click();
        },
        onFileChange() {
            const file = this.$refs.logoimage.files[0];
            let reader = new FileReader();
            reader.addEventListener(
                "load",
                function() {
                    this.logo_file_src = reader.result;
                }.bind(this),
                false
            );
            if (file) {
                if (/\.(jpe?g|png)$/i.test(file.name)) {
                    reader.readAsDataURL(file);
                    this.logo_file = file;
                } else {
                    this.logo_file_src = require("../../../assets/default-image.jpg");
                    this.$toasted.error("invalid file type!");
                    this.$refs.logoimage.value = "";
                }
            }
        },
        onKmlFileChange(type) {
            const refName = `${type}KmlFile`;
            const file = this.$refs[refName].files[0];

            if (!file) {
                return;
            }

            if (!/\.kml$/i.test(file.name)) {
                this.$toasted.error("invalid file type!");
                this.$refs[refName].value = "";
                return;
            }

            if (type === "shop") {
                this.shop_kml_file = file;
            } else {
                this.driver_kml_file = file;
            }
        },
        async onSave() {
            this.waiting = true;
            this.$store
                .dispatch("corporate/companyProfile/store", this.model)
                .then(async response => {
                    await this.uploadLogo(response.company_id);
                    await this.uploadKmlFile(response.company_id, "shop");
                    await this.uploadKmlFile(response.company_id, "driver");
                    this.$notify({ type: "success", text: response.message });
                    this.$emit("fetchData");
                    this.$emit("cancel");
                })
                .catch(error => {
                    this.$notify({ type: "error", text: error.message });
                    this.errors = new Errors(error.errors);
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        async onUpdate() {
            this.waiting = true;
            this.$store
                .dispatch("corporate/companyProfile/update", {
                    id: this.model.company_id,
                    data: this.model
                })
                .then(async response => {
                    await this.uploadLogo(this.model.company_id);
                    await this.uploadKmlFile(this.model.company_id, "shop");
                    await this.uploadKmlFile(this.model.company_id, "driver");
                    this.$notify({ type: "success", text: response.message });
                    this.$emit("cancel");
                })
                .catch(error => {
                    this.$notify({ type: "error", text: error.message });
                    this.errors = new Errors(error.errors);
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        mapClick(value) {
            this.marker.lat = value.latLng.lat();
            this.marker.lng = value.latLng.lng();
            this.model.geo_location.lat = value.latLng.lat();
            this.model.geo_location.lng = value.latLng.lng();
        },
        addBank() {
            this.model.payment_info.push({
                bank_name: "",
                currency_code: "KHR",
                currency_sign: "៛",
                account_number: "",
                account_name: ""
            });
        },
        onCurrencyCodeChange(payment, code) {
            const currency = this.currencyOptions.find(item => item.code === code);

            if (currency) {
                payment.currency_code = currency.code;
                payment.currency_sign = currency.sign;
            }
        },
        onCurrencySignChange(payment, sign) {
            const currency = this.currencyOptions.find(item => item.sign === sign);

            if (currency) {
                payment.currency_code = currency.code;
                payment.currency_sign = currency.sign;
            }
        },
        removeBank(index) {
            this.model.payment_info.splice(index, 1);
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model.company_id = this.edit_data.company_id;
                this.model.prefix_code = this.edit_data.prefix_code;
                this.model.company_name_kh = this.edit_data.company_name_kh;
                this.model.company_name_en = this.edit_data.company_name_en;
                this.model.company_address = this.edit_data.company_address;
                this.model.company_phone = this.edit_data.company_phone;
                this.model.company_email = this.edit_data.company_email;
                this.model.company_website = this.edit_data.company_website;
                this.model.company_logo = this.edit_data.company_logo;
                this.model.shop_kml_file = this.edit_data.shop_kml_file;
                this.model.driver_kml_file = this.edit_data.driver_kml_file;
                this.model.payment_info = this.edit_data.payment_info || [];

                if (this.edit_data.geo_location) {
                    this.center.lat = this.edit_data.geo_location[0].lat;
                    this.center.lng = this.edit_data.geo_location[0].lng;
                    this.marker.lat = this.edit_data.geo_location[0].lat;
                    this.marker.lng = this.edit_data.geo_location[0].lng;
                    this.model.geo_location.lat = this.edit_data.geo_location[0]
                        .lat;
                    this.model.geo_location.lng = this.edit_data.geo_location[0]
                        .lng;
                }

                if (this.edit_data.company_logo) {
                    this.logo_file_src = this.edit_data.company_logo;
                }
            }
        },
        async uploadLogo(companyId) {
            if (this.logo_file instanceof File) {
                let formData = new FormData();
                formData.append("file", this.logo_file);
                formData.append("company_id", companyId);
                await this.$store.dispatch(
                    "corporate/companyProfile/upload",
                    formData
                );
            }
            return "";
        },
        async uploadKmlFile(companyId, type) {
            const file = type === "shop" ? this.shop_kml_file : this.driver_kml_file;

            if (file instanceof File) {
                let formData = new FormData();
                formData.append("file", file);
                formData.append("company_id", companyId);
                formData.append("type", type);
                await this.$store.dispatch(
                    "corporate/companyProfile/uploadKml",
                    formData
                );
            }
            return "";
        }
    }
};
</script>
